module.exports = __webpack_public_path__ + "static/Customer Acknowledgement & Risk Disclosure Statement-c63c2b6a15451679eea42de34e5bf0c4.pdf";